import Vue from 'vue'
import App from './App.vue'
import config from './config/config'
import request from "./utils/request";
import router from './router'
import ElementUI from 'element-ui';
import $ from "jquery/dist/jquery"
import 'element-ui/lib/theme-chalk/index.css';
import "../public/iconfont/iconfont.css"

Vue.config.productionTip = false

Vue.use(ElementUI);

import '@/assets/css/scroll.css'

Vue.config.productionTip = false
// axios
Vue.prototype.$http = request
Vue.prototype.$ = $
// 后台地址配置
Vue.prototype.$config = config
// 消除Vue警告
Vue.config.productionTip = false;
// Vue.config.devtools = false;
Vue.config.silent = true;

Vue.config.devtools = true;

// import loadingDirectiive from '@/utils/loading'
// Vue.directive('loading', loadingDirectiive)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

